import { j as e } from "./atoms-v218.js";
import { forwardRef as $ } from "react";
import { BookingConfirmationHeader as R, ContentColumn as B, MobileTextWrapper as C, CenteredContent as x, RounderPicture as t, PictureMediumRow as v, GrowingPicture as r, InformationsList as c, InformationsListRow as m, InformationLabel as j, PictureColumn as b, BottomPictures as k, TextColumn as H, HeaderText as P } from "./atoms-v21027.js";
import { useBreakpoints as w } from "./atoms-v251.js";
const L = $(
  ({ className: h, colorTheme: o = "light", confirmationText: l, confirmationTitle: n, id: p, informationsList: a, pictures: i }, g) => {
    const { current: d } = w(), u = ["small", "medium"].includes(d), f = d === "small";
    return /* @__PURE__ */ e.jsx(
      R,
      {
        className: h,
        hAlign: "start",
        id: p,
        ref: g,
        tagName: "article",
        children: /* @__PURE__ */ e.jsx(B, { large: 8, max: 14, medium: 8, offset: { xLarge: 1 }, small: 4, xLarge: 14, children: u ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsxs(C, { children: [
            /* @__PURE__ */ e.jsx(x, { children: n }),
            /* @__PURE__ */ e.jsx(x, { children: l })
          ] }),
          /* @__PURE__ */ e.jsxs("div", { children: [
            f ? /* @__PURE__ */ e.jsx(t, { $position: "center", ...i[0], aspectRatio: "16/9" }) : /* @__PURE__ */ e.jsxs(v, { children: [
              /* @__PURE__ */ e.jsx(r, { $position: "left", ...i[0], aspectRatio: "1/1" }),
              /* @__PURE__ */ e.jsxs("div", { style: { display: "flex", flexDirection: "column", gap: "4px", height: "100%" }, children: [
                /* @__PURE__ */ e.jsx(r, { $fixed: !0, $position: "rightTop", ...i[1], aspectRatio: "1/1" }),
                /* @__PURE__ */ e.jsx(
                  r,
                  {
                    $fixed: !0,
                    $position: "rightBottom",
                    ...i[2],
                    aspectRatio: "1/1"
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ e.jsx(c, { $colorTheme: o, children: a.map((s) => /* @__PURE__ */ e.jsxs(m, { children: [
              /* @__PURE__ */ e.jsx(j, { $colorTheme: o, children: s.label }),
              /* @__PURE__ */ e.jsx("div", { children: s.value })
            ] }, s.label)) })
          ] })
        ] }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsxs(b, { children: [
            /* @__PURE__ */ e.jsx(t, { $position: "top", ...i[0], aspectRatio: "2/1" }),
            /* @__PURE__ */ e.jsxs(k, { children: [
              /* @__PURE__ */ e.jsx(t, { $position: "leftBottom", ...i[1], aspectRatio: "16/9" }),
              /* @__PURE__ */ e.jsx(t, { $position: "rightBottom", ...i[2], aspectRatio: "16/9" })
            ] })
          ] }),
          /* @__PURE__ */ e.jsxs(H, { children: [
            /* @__PURE__ */ e.jsxs(P, { children: [
              /* @__PURE__ */ e.jsx("div", { children: n }),
              /* @__PURE__ */ e.jsx("div", { children: l })
            ] }),
            /* @__PURE__ */ e.jsx(c, { $colorTheme: o, children: a.map((s) => /* @__PURE__ */ e.jsxs(m, { children: [
              /* @__PURE__ */ e.jsx(j, { $colorTheme: o, children: s.label }),
              /* @__PURE__ */ e.jsx("div", { children: s.value })
            ] }, s.label)) })
          ] })
        ] }) })
      }
    );
  }
);
L.displayName = "Blocks.BookingConfirmationHeader";
export {
  L as BookingConfirmationHeader
};
